import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const MenuDataSetup = lazy(() => import('./MenuDataSetup'))
const UnifiedMenuSetup = lazy(() => import('./UnifiedMenuSetup'))
const MenuItemForm = lazy(() => import('./MenuItemForm'))

const dataSetupRoutes = [
    {
        path: '/data-setup',
        component: MenuDataSetup,
        auth: authRoleAccess.dataSetup,
    },
    {
        path: '/unified-menu-setup',
        component: UnifiedMenuSetup,
        auth: authRoleAccess.dataSetup,
    },
    {
        path: '/menu-item/new',
        component: MenuItemForm,
        auth: authRoleAccess.dataSetup,
    },
    {
        path: '/menu-item/edit/:id',
        component: MenuItemForm,
        auth: authRoleAccess.dataSetup,
    },
]

export default dataSetupRoutes 